import { OrderPayloadItem } from '@/lib/types/orderPayload';
import { SyliusOrderItem } from '@/lib/types/syliusOrderItem';

/**
 * Calculates the total quantity of items in the cart.
 *
 * @param {CartItem[]} items - The array of cart items.
 * @returns {number} The total quantity of items.
 */
export const calculateTotalQuantity = (items: OrderPayloadItem[] | SyliusOrderItem[]): number => {
  if (!Array.isArray(items)) return 0;
  return items.reduce((total, item) => total + item.quantity, 0);
};
